<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :form-fields="{model: []}"
                      :url="url"
                      :permission="{}"
                      :searchs="searchs"
                      :operate="[]"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "TrxCollectionRecord",
        components: {CommonTable},
        data() {
            return {
                searchs:[{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                },  {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                url: {
                    get: '/trxCollectionRecord/listByCondition',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'phone',
                    label: '会员',
                    show: true,
                    width: '',
                }, {
                    field: 'fromAddress',
                    label: '来源地址',
                    show: true,
                    width: '',
                }, {
                    field: 'toAddress',
                    label: '归集地址',
                    show: true,
                    width: '',
                }, {
                    field: 'amount',
                    label: '金额',
                    show: true,
                    width: '',
                }, {
                    field: 'txId',
                    label: '交易ID',
                    show: true,
                    width: '',
                }, {
                    field: 'collect',  // 字段名
                    label: '是否归集',  // 字段显示名称
                    show: {
                        type: 'tag',
                        tags: [
                            {
                                key: 0,
                                value: '未归集',
                                type: 'info'
                            },
                            {
                                key: 1,
                                value: '归集',
                                type: 'success'
                            }
                        ]
                    },
                    selectData: [{
                        key: 0,
                        value: '未归集'
                    }, {
                        key: 1,
                        value: '归集'
                    }]
                }, {
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
            }
        }
    }
</script>

<style scoped>

</style>
